// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_panel {
    width: 100vw;
    height: 85vh;
    /* overflow-y: scroll; */
    background-color: #F2F2F2;
}


.dashboard_main_area {
    width: 100%;
    display: flex;
}


.vehicle_identification {
    display: flex;
    flex-direction: column;
    width: 20vw;
    height: 71vh;
    margin-left: 3%;
    margin-top: 2%;
    background: linear-gradient(180.02deg, #93BA45 0.02%, #9BBF53 41.66%, #F6F6F6 117.61%);
    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);
    /* border-top: 2px solid #93BA45; */
    /* border-radius: 17px; */
    /* padding-bottom: 4%; */
}


.vehicle_number_id {
    opacity: 0.5;
    font-weight: 400;
    font-size: 10px;
    margin-left: 22px;
    margin-top: 18px;
}

.model_title {
    margin-top: 1.5vh;
    margin-left: 1.5vw;
    font-size: 0.8vw;
    color: #333333;
}

.vehicle_model_name_text {
    background-color: white;
    margin-left: 1.5vw;
    font-size: 1vw;
    margin-top: 0.5vh;
    height: 5vh;
    padding-top: 2vh;
    padding-left: 1vw;
    width: 14.3vw;
    border-radius: 12px;
}



.reg_number {
    /* font-weight: 500; */
    font-size: 0.8vw;
    line-height: 20px;
    margin-top: 2vh;
    margin-left: 1.5vw;
    opacity: 0.7;
}

.vehicle_number {
    background-color: white;
    margin-left: 1.5vw;
    font-size: 1vw;
    margin-top: 0.5vh;
    letter-spacing: 0.5vw;
    height: 5vh;
    padding-top: 2vh;
    padding-left: 1vw;
    width: 14.3vw;
    border-radius: 12px;
}

.total_dist_head {
    margin-top: 2vh;
    margin-left: 1.5vw;
    font-size: 0.8vw;
    opacity: 0.7;
}

.dist_travelled {
    font-weight: 500;
    font-size: 1vw;
    margin-top: 0.3vh;
    margin-left: 1.5vw;
}

.insurance_det, .ideltime_det,.service_det {
    margin-top: 0vh;
    margin-left: 1.5vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-right: 6vw;
}
.insurance_head {
    font-size: 0.8vw;
}
.ideltime_det {
    margin-top: 2vh;
}
/* .insurance_det {
    margin-top: 5vh;
} */

.cr_header,.i_header {
    /* font-weight: 500; */
    font-size: 0.8vw;
    opacity: 0.7;
}

.cr_details, .i_details {
    font-weight: 500;
    font-size: 1vw;
    margin-right: 0.5vw;
}


.vehicle {
    position: absolute;
    width: 30vw;
    height: 40vh;
    margin-left: -5vw;
    margin-top: -8vh;
    z-index: 2;
}

.vehicle3 {
    position: absolute;
    width: 33vw;
    height: 41vh;
    margin-left: -4vw;
    margin-top: -12vh;
    z-index: 2;
}




.dashboard_right_side {
    margin-left: 2vw;
    margin-top: 4vh;
}
.dashboard_right_bottom {
    display: flex;
    margin-top: 2vh;
}

.engine_details {
    background-color: white;
    width: 53vw;
    height: 27vh;
    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);
    border-top: 2px solid #93BA45;
    /* border-radius: 14px; */
}



.ed_head{
    padding-top: 1vh;
    margin-left: 1.8vw;
    font-weight: 800;
    font-size: 0.9vmax;
}

.engine_detail_main {
    display: flex;
    margin-top: 2vh;
    justify-content: space-evenly;
}

.battery_details,.tire_details,.range_details {
    margin-left: 5.9vw;
}

.range_details,.battery_details {
    margin-left: 4vw;
}

.energy_icon,.battery_icon,.range_icon,.tire_icon {
    margin-left:1.5vw;
}
.range_icon {
    margin-left: 4.5vw;
}

.energy_title,.battery_title,.tire_title,.range_title {
    font-weight: 400;
    font-size: 1.8vmin;
    margin-top: 0.4vh;
    text-align: center;

}


.energy_bar_display,.battery_bar_display,.tire_bar_display,.range_bar_display {
    
    width: 10vh;
    height: 10vh;
    border-radius:50%;
    margin-top: 0.5vh;
}

.range_bar_display {
 margin-left: 3vw;
}

.energy_perc,.battery_perc,.tire_perc,.range_perc {
    text-align: center;
    padding-top: 3.6vh;
    font-weight: 800;
    font-size: 2vmin;
}

/* .energy_perc_disp,.tire_perc_disp,.range_perc_disp,.battery_perc_disp {
    box-sizing: border-box;
    width: 83.48px;
    height: 85.44px;
    background: #AACB6C;
    border: 1px solid #B4D27C;
    border-radius: 50%;
} */

.reminders {
    width: 23.6vw;
    height: 42vh;
    background-color: white;
    margin-left: 1.5vw;
    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);
    /* border-radius: 14px; */
    border-top: 2px solid #93BA45;
}

.reminder_head {
    margin-top: 1.8vh;
    margin-left: 2vw;
    font-weight: 500;
    font-size: 2.2vmin;
}

.reminder_main {
    
}

.reminder_tasks {
    display: flex;
    margin-left: 2vw;
    margin-top: 2.1vh;

    /* flex-direction: column; */
}

.reminder_icon {

}

.reminder_details {
    margin-left: 1.8vw;
}

.reminder_date {
    font-weight: 500;
    font-size: 1.5vmin;
}

.task_descri {
    font-weight: 400;
    font-size: 1.3vmin;
    color: #76787A;
    margin-top:0.2vh
}

.task_status {
    width: auto;
    padding: 0.8vmin;
    background: #F0F0EF;;
    border-radius: 4px;
    font-weight: 500;
    font-size: 1.15vmin;
    color: #000000;;
    margin-top: 0.8vh;
}

.task_insurance{
    width: 5.0vw;
}

.location_area {
    width: 28vw;
    height: 42vh;
    background-color: white;
    /* border-radius: 14px; */
    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);
    border-top: 2px solid #93BA45;
}

.online_status {
    margin-left: 1.5vw;
    margin-top: 2vh;
}

.device_status {
    display: flex;
}

.device_status_text {
    margin-left: 0.5vw;
    margin-top: .5vh;
    font-size: 0.9vw;
}

.address_map {
    z-index: 4;
    background-color: white;
    position: absolute;
    margin-top: 0vh;
    margin-left: 0vw;
    padding-left: .2vmax;
    padding-right: .2vmax;
    display: flex;
    flex-direction: row;
    width: 27.6vw;
    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.05);
    justify-content: flex-start;
}

.current_location_map {
    color: #93BA45;
    width: 130px;
}
.address_location {
    margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ModelBoard/VehicleDashboard/index.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,sFAAsF;IACtF,6CAA6C;IAC7C,mCAAmC;IACnC,yBAAyB;IACzB,wBAAwB;AAC5B;;;AAGA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;;;AAIA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;;GAEG;;AAEH;IACI,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;AACd;;;;;AAKA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,6BAA6B;IAC7B,yBAAyB;AAC7B;;;;AAIA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;;AAEtB;;;AAGA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;;;;;GAOG;;AAEH;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,6CAA6C;IAC7C,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;;IAEjB,4BAA4B;AAChC;;AAEA;;AAEA;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,6CAA6C;IAC7C,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".main_panel {\r\n    width: 100vw;\r\n    height: 85vh;\r\n    /* overflow-y: scroll; */\r\n    background-color: #F2F2F2;\r\n}\r\n\r\n\r\n.dashboard_main_area {\r\n    width: 100%;\r\n    display: flex;\r\n}\r\n\r\n\r\n.vehicle_identification {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 20vw;\r\n    height: 71vh;\r\n    margin-left: 3%;\r\n    margin-top: 2%;\r\n    background: linear-gradient(180.02deg, #93BA45 0.02%, #9BBF53 41.66%, #F6F6F6 117.61%);\r\n    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);\r\n    /* border-top: 2px solid #93BA45; */\r\n    /* border-radius: 17px; */\r\n    /* padding-bottom: 4%; */\r\n}\r\n\r\n\r\n.vehicle_number_id {\r\n    opacity: 0.5;\r\n    font-weight: 400;\r\n    font-size: 10px;\r\n    margin-left: 22px;\r\n    margin-top: 18px;\r\n}\r\n\r\n.model_title {\r\n    margin-top: 1.5vh;\r\n    margin-left: 1.5vw;\r\n    font-size: 0.8vw;\r\n    color: #333333;\r\n}\r\n\r\n.vehicle_model_name_text {\r\n    background-color: white;\r\n    margin-left: 1.5vw;\r\n    font-size: 1vw;\r\n    margin-top: 0.5vh;\r\n    height: 5vh;\r\n    padding-top: 2vh;\r\n    padding-left: 1vw;\r\n    width: 14.3vw;\r\n    border-radius: 12px;\r\n}\r\n\r\n\r\n\r\n.reg_number {\r\n    /* font-weight: 500; */\r\n    font-size: 0.8vw;\r\n    line-height: 20px;\r\n    margin-top: 2vh;\r\n    margin-left: 1.5vw;\r\n    opacity: 0.7;\r\n}\r\n\r\n.vehicle_number {\r\n    background-color: white;\r\n    margin-left: 1.5vw;\r\n    font-size: 1vw;\r\n    margin-top: 0.5vh;\r\n    letter-spacing: 0.5vw;\r\n    height: 5vh;\r\n    padding-top: 2vh;\r\n    padding-left: 1vw;\r\n    width: 14.3vw;\r\n    border-radius: 12px;\r\n}\r\n\r\n.total_dist_head {\r\n    margin-top: 2vh;\r\n    margin-left: 1.5vw;\r\n    font-size: 0.8vw;\r\n    opacity: 0.7;\r\n}\r\n\r\n.dist_travelled {\r\n    font-weight: 500;\r\n    font-size: 1vw;\r\n    margin-top: 0.3vh;\r\n    margin-left: 1.5vw;\r\n}\r\n\r\n.insurance_det, .ideltime_det,.service_det {\r\n    margin-top: 0vh;\r\n    margin-left: 1.5vw;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    margin-right: 6vw;\r\n}\r\n.insurance_head {\r\n    font-size: 0.8vw;\r\n}\r\n.ideltime_det {\r\n    margin-top: 2vh;\r\n}\r\n/* .insurance_det {\r\n    margin-top: 5vh;\r\n} */\r\n\r\n.cr_header,.i_header {\r\n    /* font-weight: 500; */\r\n    font-size: 0.8vw;\r\n    opacity: 0.7;\r\n}\r\n\r\n.cr_details, .i_details {\r\n    font-weight: 500;\r\n    font-size: 1vw;\r\n    margin-right: 0.5vw;\r\n}\r\n\r\n\r\n.vehicle {\r\n    position: absolute;\r\n    width: 30vw;\r\n    height: 40vh;\r\n    margin-left: -5vw;\r\n    margin-top: -8vh;\r\n    z-index: 2;\r\n}\r\n\r\n.vehicle3 {\r\n    position: absolute;\r\n    width: 33vw;\r\n    height: 41vh;\r\n    margin-left: -4vw;\r\n    margin-top: -12vh;\r\n    z-index: 2;\r\n}\r\n\r\n\r\n\r\n\r\n.dashboard_right_side {\r\n    margin-left: 2vw;\r\n    margin-top: 4vh;\r\n}\r\n.dashboard_right_bottom {\r\n    display: flex;\r\n    margin-top: 2vh;\r\n}\r\n\r\n.engine_details {\r\n    background-color: white;\r\n    width: 53vw;\r\n    height: 27vh;\r\n    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);\r\n    border-top: 2px solid #93BA45;\r\n    /* border-radius: 14px; */\r\n}\r\n\r\n\r\n\r\n.ed_head{\r\n    padding-top: 1vh;\r\n    margin-left: 1.8vw;\r\n    font-weight: 800;\r\n    font-size: 0.9vmax;\r\n}\r\n\r\n.engine_detail_main {\r\n    display: flex;\r\n    margin-top: 2vh;\r\n    justify-content: space-evenly;\r\n}\r\n\r\n.battery_details,.tire_details,.range_details {\r\n    margin-left: 5.9vw;\r\n}\r\n\r\n.range_details,.battery_details {\r\n    margin-left: 4vw;\r\n}\r\n\r\n.energy_icon,.battery_icon,.range_icon,.tire_icon {\r\n    margin-left:1.5vw;\r\n}\r\n.range_icon {\r\n    margin-left: 4.5vw;\r\n}\r\n\r\n.energy_title,.battery_title,.tire_title,.range_title {\r\n    font-weight: 400;\r\n    font-size: 1.8vmin;\r\n    margin-top: 0.4vh;\r\n    text-align: center;\r\n\r\n}\r\n\r\n\r\n.energy_bar_display,.battery_bar_display,.tire_bar_display,.range_bar_display {\r\n    \r\n    width: 10vh;\r\n    height: 10vh;\r\n    border-radius:50%;\r\n    margin-top: 0.5vh;\r\n}\r\n\r\n.range_bar_display {\r\n margin-left: 3vw;\r\n}\r\n\r\n.energy_perc,.battery_perc,.tire_perc,.range_perc {\r\n    text-align: center;\r\n    padding-top: 3.6vh;\r\n    font-weight: 800;\r\n    font-size: 2vmin;\r\n}\r\n\r\n/* .energy_perc_disp,.tire_perc_disp,.range_perc_disp,.battery_perc_disp {\r\n    box-sizing: border-box;\r\n    width: 83.48px;\r\n    height: 85.44px;\r\n    background: #AACB6C;\r\n    border: 1px solid #B4D27C;\r\n    border-radius: 50%;\r\n} */\r\n\r\n.reminders {\r\n    width: 23.6vw;\r\n    height: 42vh;\r\n    background-color: white;\r\n    margin-left: 1.5vw;\r\n    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);\r\n    /* border-radius: 14px; */\r\n    border-top: 2px solid #93BA45;\r\n}\r\n\r\n.reminder_head {\r\n    margin-top: 1.8vh;\r\n    margin-left: 2vw;\r\n    font-weight: 500;\r\n    font-size: 2.2vmin;\r\n}\r\n\r\n.reminder_main {\r\n    \r\n}\r\n\r\n.reminder_tasks {\r\n    display: flex;\r\n    margin-left: 2vw;\r\n    margin-top: 2.1vh;\r\n\r\n    /* flex-direction: column; */\r\n}\r\n\r\n.reminder_icon {\r\n\r\n}\r\n\r\n.reminder_details {\r\n    margin-left: 1.8vw;\r\n}\r\n\r\n.reminder_date {\r\n    font-weight: 500;\r\n    font-size: 1.5vmin;\r\n}\r\n\r\n.task_descri {\r\n    font-weight: 400;\r\n    font-size: 1.3vmin;\r\n    color: #76787A;\r\n    margin-top:0.2vh\r\n}\r\n\r\n.task_status {\r\n    width: auto;\r\n    padding: 0.8vmin;\r\n    background: #F0F0EF;;\r\n    border-radius: 4px;\r\n    font-weight: 500;\r\n    font-size: 1.15vmin;\r\n    color: #000000;;\r\n    margin-top: 0.8vh;\r\n}\r\n\r\n.task_insurance{\r\n    width: 5.0vw;\r\n}\r\n\r\n.location_area {\r\n    width: 28vw;\r\n    height: 42vh;\r\n    background-color: white;\r\n    /* border-radius: 14px; */\r\n    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.02);\r\n    border-top: 2px solid #93BA45;\r\n}\r\n\r\n.online_status {\r\n    margin-left: 1.5vw;\r\n    margin-top: 2vh;\r\n}\r\n\r\n.device_status {\r\n    display: flex;\r\n}\r\n\r\n.device_status_text {\r\n    margin-left: 0.5vw;\r\n    margin-top: .5vh;\r\n    font-size: 0.9vw;\r\n}\r\n\r\n.address_map {\r\n    z-index: 4;\r\n    background-color: white;\r\n    position: absolute;\r\n    margin-top: 0vh;\r\n    margin-left: 0vw;\r\n    padding-left: .2vmax;\r\n    padding-right: .2vmax;\r\n    display: flex;\r\n    flex-direction: row;\r\n    width: 27.6vw;\r\n    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.05);\r\n    justify-content: flex-start;\r\n}\r\n\r\n.current_location_map {\r\n    color: #93BA45;\r\n    width: 130px;\r\n}\r\n.address_location {\r\n    margin-left: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
